export default __webpack_public_path__ + "static/media/stripe.f0beea50.png";